import { render, staticRenderFns } from "./behavior-form.vue?vue&type=template&id=42910de8&scoped=true"
import script from "./behavior-form.vue?vue&type=script&lang=js"
export * from "./behavior-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42910de8",
  null
  
)

export default component.exports